import { render, staticRenderFns } from "./TodoList.vue?vue&type=template&id=7c52c651&scoped=true"
import script from "./TodoList.vue?vue&type=script&lang=js"
export * from "./TodoList.vue?vue&type=script&lang=js"
import style0 from "./TodoList.vue?vue&type=style&index=0&id=7c52c651&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c52c651",
  null
  
)

export default component.exports